import React, { useState, useEffect } from 'react';
import { useRecordContext, useGetIdentity, useNotify } from 'react-admin';
import { MenuItem } from '@mui/material';
import { canMessageUser } from './messagingUtils';
import Parse from 'parse';

/**
 * SendMessageButton - Allows users to send messages to other users in the hierarchy
 * Should be used within an ActionsMenu component
 */
const SendMessageButton = ({ record: propRecord, onClick }) => {
  const contextRecord = useRecordContext();
  const record = propRecord || contextRecord;
  const { data: currentUser } = useGetIdentity();
  const notify = useNotify();
  const [messagingEnabled, setMessagingEnabled] = useState(true);

  // Check if messaging is enabled
  useEffect(() => {
    const checkMessagingStatus = async () => {
      try {
        const query = new Parse.Query('GameSettings');
        const settings = await query.first({ useMasterKey: true });
        if (settings) {
          setMessagingEnabled(settings.get('messaging') === true);
        }
      } catch (error) {
        console.error('Error checking messaging status:', error);
      }
    };
    
    checkMessagingStatus();
  }, []);

  console.log('SendMessageButton render:', { 
    record, 
    currentUser, 
    propRecord, 
    contextRecord,
    messagingEnabled
  });

  // Don't show button if messaging is disabled
  if (!messagingEnabled) {
    console.log('SendMessageButton: Messaging disabled globally');
    return null;
  }

  if (!record || !currentUser) {
    console.log('SendMessageButton: Missing record or currentUser');
    return null;
  }

  // Don't show button for own record
  if (record.id === currentUser.userId) {
    console.log('SendMessageButton: Own record, hiding button');
    return null;
  }

  // Don't show button for Player role (Players not allowed in messaging)
  const targetUserRole = record.role?.name || record.roleName || record.role;
  if (targetUserRole === 'Player') {
    console.log('SendMessageButton: Player role, hiding button');
    return null;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    
    // Get roles
    const currentUserRole = currentUser.userRoleName;

    console.log('SendMessageButton clicked:', {
      currentUserRole,
      targetUserRole,
      record
    });

    // Check if messaging is allowed
    const permission = canMessageUser(currentUserRole, targetUserRole);
    
    if (!permission.allowed) {
      notify(permission.reason, { type: 'warning' });
      return;
    }

    // Trigger global messaging widget with pre-selected user
    if (window.openMessagingWithUser) {
      window.openMessagingWithUser({
        userId: record.id,
        username: record.username,
        role: targetUserRole
      });
    } else {
      notify('Messaging feature not available', { type: 'warning' });
    }
    
    // Call the parent onClick if provided (to close the menu)
    if (onClick) {
      onClick(e);
    }
  };

  // Check if messaging is allowed to show/hide button
  const currentUserRole = currentUser.userRoleName;
  
  console.log('SendMessageButton permission check:', {
    currentUserRole,
    targetUserRole,
    record
  });
  
  const permission = canMessageUser(currentUserRole, targetUserRole);

  console.log('SendMessageButton permission result:', permission);

  // Don't show button if messaging not allowed
  if (!permission.allowed) {
    console.log('SendMessageButton: Permission denied, hiding button');
    return null;
  }

  console.log('SendMessageButton: Rendering button');

  return (
    <MenuItem onClick={handleClick} sx={{ color: '#000' }}>
      Send Message
    </MenuItem>
  );
};

export default SendMessageButton;
